import { Skeleton, Tooltip } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { Link } from "@src/components/ui-kit";
import { currency } from "@src/utils/formatters";

interface BudgetExceededProps {
  budgetExceeded: number;
  ourWorkItems?: { id: string; name: string; budgetExceeded: number }[];
  expensesItems?: { id: string; name: string; budgetExceeded: number }[];
  code: string;
  fetching?: boolean;
}

export const BudgetExceeded = (props: BudgetExceededProps) => {
  return (
    <Tooltip
      isDisabled={!props.ourWorkItems?.length && !props.expensesItems?.length}
      label={
        <div className="flex flex-col items-center p-4 justify-center text-white text-lg">
          <h4 className="font-bold mb-1">{t`Budget Exceeded`}</h4>
          {props?.ourWorkItems?.map((item) => (
            <div key={item.id} className="mb-1">
              <span>{item.name}: </span>
              <span>{currency.formatByWorkspace(item.budgetExceeded)}</span>
            </div>
          ))}
          {props?.expensesItems?.map((item) => (
            <div key={item.id} className="mb-1">
              <span>{item.name}: </span>
              <span>{currency.formatByWorkspace(item.budgetExceeded)}</span>
            </div>
          ))}
        </div>
      }
    >
      <Skeleton h="3" isLoaded={!props.fetching}>
        <div className="flex justify-center">
          {props.budgetExceeded !== 0 ? (
            <Link
              href={{
                pathname: "/reports/budget-exceeded",
                query: { search: props.code },
              }}
            >
              <span className="text-red">
                {currency.formatByWorkspace(props.budgetExceeded)}
              </span>
            </Link>
          ) : (
            currency.formatByWorkspace(props.budgetExceeded)
          )}
        </div>
      </Skeleton>
    </Tooltip>
  );
};
